import { useRef, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import vcreateLogo from '../images/Vcreate-logo.svg';

const Navbar = () => {
  const { userToken, signOut } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const tglbtnRef = useRef<HTMLDivElement>(null);
  const navlstRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const tglbtn = tglbtnRef.current;
    const navlst = navlstRef.current;

    const toggleNav = () => {
      if (navlst) {
        navlst.classList.toggle("navbar-active");
      }
    };

    if (tglbtn && navlst) {
      tglbtn.addEventListener('click', toggleNav);
    }

    return () => {
      if (tglbtn) {
        tglbtn.removeEventListener('click', toggleNav);
      }
    };
  }, []);

  const handleSignOut = () => {
    signOut();
    navigate("/");
  };

  return (
    <nav id="navbar">
      <div className="logo-container">
        <a href="/" title="Vcreate logo">
          <img className="logo-image" src={vcreateLogo} alt="Vcreate logo" title="Vcreate logo"/>
        </a>
      </div>
      <div id="nav-list" className="nav-menu" ref={navlstRef}>
        {location.pathname.includes("/jobs") && <Link to={location.pathname} className="active">Results</Link>}
        <Link to="/" className={location.pathname === "/" ? "active first-child" : "inactive first-child"}>MHC Attention</Link>
        <Link to="/tutorial" className={location.pathname === "/tutorial" ? "active" : "inactive"}>Tutorial</Link>
        {!userToken && <Link to="/signin" className={location.pathname === "/signin" ? "active" : "inactive"}>Sign In</Link>}
        {userToken && <button className="nav-action inactive" onClick={handleSignOut}>Sign Out</button>}
      </div>
      <div id="burger-menu" className="menu-icon" ref={tglbtnRef}>
        <div className="bar top"></div>
        <div className="bar"></div>
        <div className="bar"></div>
      </div>
    </nav>
  );
};

export default Navbar;
